import { reactive } from 'vue';
import { getGoodsList, getImgGoodsList } from '@/apis/goods';
import { ElMessage } from 'element-plus';

export const useGoodsSearch = ({ extraRequestFn } = {}) => {
  const state = reactive({
    loading: false, // 是否请求中
    pageLoading: false, // 加载更多数据
    list: [], // 商品列表
    noData: false, // 数据是否为空
    noMore: false, // 没有更多
    requestFail: false, // 请求失败
    sourceType: 'AL', // AL 1688、TB 淘宝
    pagination: {
      beginPage: 1,
      pageSize: 20
    }
  });
  const requestFn = params => {
    if (extraRequestFn) {
      return extraRequestFn(params);
    }
    return (params.searchType !== 'picture' ? getGoodsList : getImgGoodsList)(
      params
    );
  };

  const resetParams = () => {
    state.pagination.beginPage = 1;
    state.pagination.pageSize = 20;
    state.loading =
      state.pageLoading =
      state.noData =
      state.noMore =
      state.requestFail =
        false;
    state.list = [];
  };
  const getSearchList = async params => {
    if (state.loading || state.pageLoading) return;
    // this.resetLoading();
    if (state.pagination.beginPage === 1) {
      state.loading = true;
    } else {
      state.pageLoading = true;
    }
    params = {
      ...state.pagination,
      ...params
    };
    try {
      const res = (await requestFn(params)) || {};

      state.list.push(
        ...(res?.items || []).map(it => ({ ...it, source: params.source }))
      );
      if (!res?.items.length) {
        // 加载完成
        state.noMore = true;
      } else if (state.list.length === 0) {
        state.noData = true;
      } else {
        state.pagination.beginPage++;
      }
    } catch (error) {
      ElMessage({ type: 'error', message: error });
    } finally {
      state.pageLoading = false;
      state.loading = false;
    }
  };
  return [state, getSearchList, resetParams];
};
